export class BankAccountOut {
  account_number: string = ""
  branch_code: string = ""
  bank_code: string = ""
  rib_key: string = ""
  operator_id: string = ""
}
